export default __webpack_public_path__ + "static/media/47.4b245c2f.jpg";